export const LISTA_BENS_FIELDS = {
    ID_COTACAO_BEM: 'idCotacaoBem',
    CODIGO_COTACAO: 'codigoCotacao',
    BENS: 'bens',
    GARANTIA: 'inGarantia',
    DETALHE_EQUIPAMENTO: {
        THIS: 'detalheEquipamento',
        FABRICANTE: 'fabricante',
        MODELO: 'modelo',
        CHASSI: 'chassiOuSerie'
    },
    BENEFICIARIOS: {
        THIS: 'beneficiarios',
        CPF: 'cpf',
        CNPJ: 'cnpj',
        NOME_ABREVIADO: 'nomeAbreviado',
        NOME_COMPLETO: 'nomeCompleto',
        PERCENTUAL_PARTICIPACAO: 'percParticipacao',
        BENEFICIARIO_PROPRIO_ASSEGURADO: 'beneficiarioProprioSegurado'
    },
    DADOS_BANCARIOS: {
        THIS: 'dadosBancarios',
        BANCO_ID: 'bancoId',
        DIGITO_AGENCIA: 'digitoAgencia',
        DIGITO_CONTA: 'digitoConta',
        NUMERO_AGENCIA: 'numeroAgencia',
        NUMERO_CONTA: 'numeroConta',
        TIPO_CONTA: 'tipoConta',
        FORMA_PAGAMENTO: 'formaPagamento',
        DIA_VENCIMENTO: 'diaVencimento',
        NOME_BANCO: 'nomeBanco',
        BANCO: 'banco'
    },
    GEOLOCALIZACAO: {
        THIS: 'coordenadaGeografica',
        LATITUDE: 'latitude',
        LONGITUDE: 'longitude',
        GRAU: 'grau',
        MINUTO: 'minuto',
        SEGUNDO: 'segundo',
        DIRECAO: 'direcao',
        POLIGONOS: 'poligonos'
    },
    ENDERECO: {
        THIS: 'endereco',
        BAIRRO: 'bairro',
        CEP: 'cep',
        CIDADE: 'cidade',
        COMPLEMENTO: 'complemento',
        LOGRADOURO: 'logradouro',
        NOME_PROPRIEDADE: 'nomePropriedade',
        NUMERO: 'numero',
        UF: 'uf'
    },
    INFORMACAO_ADICIONAL: {
        THIS: 'informacoesAdicionais',
        EMAIL_ADICIONAL: 'email',
        EMAIL_SOLICITANTE: 'emailSolicitante',
        TELEFONE_ADICIONAL: 'telefone'
    },
    COCORRETAGEM: {
        THIS: 'coCorretagem',
        CNPJ: 'cnpj',
        NOME_CORRETORA: 'nomeCorretora'
    }
};
